import type React from 'react';
import {useMemo} from 'react';
import {
  INPUT_METHODS,
  INPUT_METHOD_REPORT,
  type InputMethod,
} from '../../../constants/inputMethods';
import {InputMethodSelectionModal} from '../Presenter/Progress/InputMethodSelectionModal';

type Props = {
  opened: boolean;
  onClose: () => void;
  onMethodSelected?: (method: InputMethod) => void;
  onBack?: () => void;
  hasReportData?: boolean;
  isAddingEntryManagement?: boolean;
};

export const InputMethodSelectionModalContainer: React.FC<Props> = ({
  opened,
  onClose,
  onMethodSelected = () => {},
  onBack,
  hasReportData = false,
  isAddingEntryManagement = false,
}) => {
  // 戻るボタンのハンドラー
  const handleBack = () => {
    // onBackがある場合は前のモーダルに戻り、ない場合はモーダルを閉じる
    if (onBack) {
      onBack();
    } else {
      onClose();
    }
  };

  // 表示する入力方法をフィルタリング
  const filteredMethods = useMemo(() => {
    return INPUT_METHODS.filter((method) => {
      // 体験記からの入力は表示条件を満たす場合のみ表示
      if (method.id === INPUT_METHOD_REPORT) {
        return hasReportData;
      }
      return true;
    });
  }, [hasReportData]);

  return (
    <InputMethodSelectionModal
      opened={opened}
      onClose={onClose}
      methods={filteredMethods}
      onSelectMethod={onMethodSelected}
      onBack={handleBack}
      isAddingEntryManagement={isAddingEntryManagement}
    />
  );
};
